<template>
  <div class="tva-row highlight-container">
    <div class="tva-col-md-8 text">{{content.text}}</div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
.highlight-container{
  display: flex;
  justify-content: center;
  padding-top: 56px;
  padding-bottom: 56px;
  .text{
    @include mdf-highlight;
  }
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .highlight-container{
    display: flex;
    justify-content: center;
    padding-top: 56px;
    .text{
      @include mdf-highlight-mobile;
    }
  }
}
</style>
